<template>
  <generic-modal :title="$t('receipt')" ref="generic_modal">
    <form>
      <div class="field">
        <label class="label">{{ $t("date") }}</label>
        <generic-calendar
          type="date"
          display_mode="dialog"
          ref="date_calendar"
          @selected="date_changed"
        />
      </div>
      <div class="field">
        <label class="label">{{ $t("received from") }}</label>
        <div class="control">
          <input class="input" type="text" v-model="meta.received_from" />
        </div>
      </div>
      <div class="field">
        <label class="label">{{ $t("amount") }}</label>
        <div class="control">
          <input
            class="input"
            type="number"
            step="0.01"
            v-model="meta.amount"
          />
        </div>
      </div>
      <div class="field">
        <label class="label">{{ $t("email") }}</label>
        <div class="control">
          <input class="input" type="text" v-model="meta.email" />
        </div>
      </div>
      <div class="field">
        <label class="label">{{ $t("receipt number") }}</label>
        <div class="field has-addons">
          <div class="control">
            <input class="input" type="text" v-model="meta.receipt_number" />
          </div>
          <div class="control">
            <div class="button is-info" @click="generate">
              <span class="icon">
                <i class="fa fa-bolt"></i>
              </span>
              <span>{{ $t("generate") }}</span>
            </div>
          </div>
        </div>
      </div>
    </form>
    <div class="notification is-danger mt-5" v-if="error">
      <p v-html="error"></p>
    </div>
    <template v-slot:footer>
      <button
        class="button is-primary is-rounded"
        @click="save"
        :disabled="is_form_invalid"
      >
        <span class="icon">
          <i class="fa fa-save"></i>
        </span>
        <span>{{ $t("save") }}</span>
      </button>
      <button class="button is-rounded" @click="close_modal">
        <span class="icon">
          <i class="fa fa-close"></i>
        </span>
        <span>{{ $t("cancel") }}</span>
      </button>
    </template>
  </generic-modal>
</template>

<script>
import {
  put,
  error_message,
  get,
  post,
  error_alert,
  generate_error_message_text,
  get_currency_settings,
} from "@/utils";
import GenericModal from "@/components/generic_modal/Index.vue";
import GenericCalendar from "@/components/generic_calendar/Index.vue";

export default {
  name: "ReceiptModal",
  components: { GenericModal, GenericCalendar },
  data() {
    return {
      meta: {},
      error: "",
    };
  },
  computed: {
    is_form_invalid() {
      let v = this;
      // return false;
      return (
        // !v.meta.received_from ||
        // !v.meta.email ||
        !v.meta.receipt_number ||
        !v.meta.date ||
        !v.meta.amount ||
        isNaN(v.meta.amount)
      );
    },
  },
  methods: {
    close_modal() {
      let v = this;
      v.$refs.generic_modal.close_modal();
      v.set_initial_state();
    },
    show_modal() {
      let v = this;
      v.set_initial_state();
      v.$refs.generic_modal.show_modal();
    },
    edit_modal(uuid) {
      let v = this;
      v.set_initial_state();

      get("/receipt", { uuid: uuid })
        .then((element) => {
          v.meta = element;
          v.$refs.generic_modal.show_modal();
          if (element.date) v.$refs.date_calendar.set_date(element.date);
        })
        .catch((error) => {
          v.error = generate_error_message_text(error);
        });
    },
    save() {
      let v = this;
      if (!v.meta.uuid)
        put("/receipt", v.meta)
          .then(() => {
            v.$emit("success");
            v.$refs.generic_modal.close_modal();
          })
          .catch((error) => {
            v.error = generate_error_message_text(error);
          });
      else
        post("/receipt", v.meta)
          .then(() => {
            v.$emit("success");
            v.$refs.generic_modal.close_modal();
          })
          .catch((error) => {
            v.error = generate_error_message_text(error);
          });
    },
    set_initial_state() {
      let v = this;
      v.meta = {
        name: "",
        settings: {},
      };
      v.$refs.date_calendar.set_date(new Date());
      v.error = "";
      // v.uuid = "";
    },
    date_changed(date) {
      let v = this;
      v.meta.date = date;
    },
    generate() {
      let v = this;
      get("/receipt/generate", {})
        .then((r) => {
          v.meta.receipt_number = r;
        })
        .catch((error) => {
          v.error = generate_error_message_text(error);
        });
    },
  },
  mounted() {},
  watch: {},
};
</script>
<style></style>
